var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTravelLuggageAndBags(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3307_1417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3307_1417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66666 15.1667V14.5C4.29999 14.5 3.98611 14.3695 3.72499 14.1084C3.46388 13.8473 3.33333 13.5334 3.33333 13.1667V5.83337C3.33333 5.46671 3.46388 5.15282 3.72499 4.89171C3.98611 4.6306 4.29999 4.50004 4.66666 4.50004H5.99999V2.50004C5.99999 2.31115 6.06388 2.15282 6.19166 2.02504C6.31944 1.89726 6.47777 1.83337 6.66666 1.83337H9.33333C9.52222 1.83337 9.68055 1.89726 9.80833 2.02504C9.93611 2.15282 9.99999 2.31115 9.99999 2.50004V4.50004H11.3333C11.7 4.50004 12.0139 4.6306 12.275 4.89171C12.5361 5.15282 12.6667 5.46671 12.6667 5.83337V13.1667C12.6667 13.5334 12.5361 13.8473 12.275 14.1084C12.0139 14.3695 11.7 14.5 11.3333 14.5V15.1667H9.99999V14.5H5.99999V15.1667H4.66666ZM7.33333 4.50004H8.66666V3.16671H7.33333V4.50004ZM7.99999 8.50004C8.58888 8.50004 9.16388 8.42504 9.725 8.27504C10.2861 8.12504 10.8222 7.90004 11.3333 7.60004V5.83337H4.66666V7.60004C5.17777 7.90004 5.71388 8.12504 6.27499 8.27504C6.83611 8.42504 7.41111 8.50004 7.99999 8.50004ZM7.33333 10.5V9.80004C6.86666 9.74448 6.41111 9.66115 5.96666 9.55004C5.52222 9.43893 5.08888 9.28893 4.66666 9.10004V13.1667H11.3333V9.10004C10.9111 9.28893 10.4778 9.43893 10.0333 9.55004C9.58888 9.66115 9.13333 9.74448 8.66666 9.80004V10.5H7.33333Z",
    fill: "#73D13D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelLuggageAndBags);
export default __webpack_public_path__ + "static/media/travel_luggage_and_bags.e97d2e381c825241f90b97ec34dc754e.svg";
export { ForwardRef as ReactComponent };